@if (showUnfinishedOrderModal()) {
    <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5); z-index: 1050;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg">
                <div class="modal-header border-bottom bg-light">
                    <h5 class="modal-title fw-bold text-warning">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i>Unfinished Order Found
                    </h5>
                </div>
                <div class="modal-body p-4 bg-white text-center">
                    <p class="mb-4 fs-5 text-muted">You cannot start a new personal order until you finish or discard your pending cart order.</p>
                </div>
                <div class="modal-footer bg-light border-top justify-content-center">
                    <button class="btn btn-primary px-4 fw-bold shadow-sm" (click)="goToCart()">Go to Cart</button>
                    <button class="btn btn-outline-danger px-4 fw-bold" (click)="destroyPendingCart()">Destroy Cart</button>
                </div>
            </div>
        </div>
    </div>
}

<div class="row p-md-3 pt-3 document-case-container">
    <div class="col-lg-6 personal-single-document__column">
        @if (sidebarSection()) {
            <div class="sidebar-section-card p-4 rounded-4 shadow-sm bg-white border border-light-subtle mb-4">
                <div class="sidebar-header mb-3">
                    @if (sidebarSection()?.title) {
                        <h3 class="sidebar-title fw-bold text-dark mb-1">
                            {{ sidebarSection()?.title }}
                        </h3>
                    }
                    @if (sidebarSection()?.subtitle) {
                        <p class="sidebar-subtitle text-muted small mb-0">
                            {{ sidebarSection()?.subtitle }}
                        </p>
                    }
                </div>
                <div [innerHTML]="sidebarSection()?.content" class="sidebar-body dynamic-content-col"></div>
            </div>
        }
        @for (row of sectionsRows(); track $index; let rowIndex = $index) {
        @if (row.length > 0) {
        @if (row[0].section_type === 'title') {
        <h1 class="personal-single-document__h1">
            {{row[0].content.replace(/\$\w+/g, '')}}
        </h1>
        } @else {
        @for (item of row; track $index; let itemIndex = $index) {
            @if (item.section_type === 'faq') {
                <div [class]="'col-md-'+(12/row.length)" class="faq-container my-3">
                    <div class="faq-header mb-4 text-center text-md-start">
                        <span class="faq-badge badge px-3 py-2 rounded-pill mb-2">FAQ</span>
                        <h2 class="faq-section-title fw-bold mb-2">
                            {{ item.title || 'Frequently Asked Questions' }}
                        </h2>
                        @if (item.subtitle) {
                            <p class="faq-section-subtitle text-muted">{{ item.subtitle }}</p>
                        }
                    </div>
                    <div class="accordion custom-faq-accordion" [id]="'faqAccordion-pers-' + rowIndex + '-' + itemIndex">
                        @for (faq of parseFaq(item.content); track $index; let faqIndex = $index) {
                            <div class="accordion-item mb-3 border rounded-3 shadow-sm overflow-hidden">
                                <h2 class="accordion-header" [id]="'heading-pers-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                    <button 
                                        class="accordion-button fw-semibold py-3 px-4" 
                                        [class.collapsed]="faqIndex !== 0"
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        [attr.data-bs-target]="'#collapse-pers-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                        [attr.aria-expanded]="faqIndex === 0 ? 'true' : 'false'" 
                                        [attr.aria-controls]="'collapse-pers-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                        <span class="faq-question-text">{{ faq.question }}</span>
                                    </button>
                                </h2>
                                <div 
                                    [id]="'collapse-pers-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                    class="accordion-collapse collapse" 
                                    [class.show]="faqIndex === 0"
                                    [attr.aria-labelledby]="'heading-pers-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                    [attr.data-bs-parent]="'#faqAccordion-pers-' + rowIndex + '-' + itemIndex">
                                    <div class="accordion-body p-4 bg-white text-secondary">
                                        <div [innerHTML]="faq.answers || faq.answer" class="dynamic-content-col"></div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            } @else if (item.section_type !== 'sidebar') {
                <div [class]="'col-md-'+(12/row.length)">
                    @for (segment of sortTheMail(item.content); track $index) {
                        @if (segment.componentToBootUp) {
                            <ng-container [ngComponentOutlet]="segment.componentToBootUp">
                            </ng-container>
                        } @else {
                            <div [innerHTML]="segment.html"></div>
                        }
                    }
                </div>
            }
        }
        }
        }
        }
        <table class="table table-borderd table-striped personal-document-table" cellpadding="8" ellspacing="0">
            <thead>
                <tr>
                    <th></th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><b>ApostillePrice</b></td>
                    <td>{{ stateDetails()?.apostille_fee }}</td>
                </tr>

                <tr>
                    <td><b>Processing Time</b></td>
                    <td>
                        {{ stateDetails()?.processing_time }}

                    </td>
                </tr>
                <tr>
                    <td><b>Mailing Address (FedEx)</b></td>
                    <td>{{ formattedAddress() }}</td>
                </tr>
                <tr>
                    <td><b>Phone Number</b></td>
                    <td>{{ formattedPhone() }}</td>
                </tr>

            </tbody>
        </table>

        <h3>
            Please fill the form
            <img src="./assets/imgs/arrowRight.gif" alt="arrow" style="width:100px; display: inline !important; box-shadow: unset !important; border: 0 !important;">
            <!-- then click
            <span style="color: blue; cursor: pointer"> Procced</span> -->
        </h3>

        <div class="personal-document-content">
            <h2>
                Avoiding Rejection: A Guide to the {{ stateDetails()?.name || 'State' }} {{ matchingDoc()?.name || 'Birth Certificate' }} Apostille Process
            </h2>

            @if (matchingDoc(); as doc) {
                @if (doc.description_document || doc.description_original || doc.description_copy) {
                    <div class="doc-descriptions my-3">
                        @if (doc.description_document) {
                            <div class="mb-2" [innerHTML]="doc.description_document"></div>
                        }
                        @if (doc.description_original) {
                            <div class="mb-2">
                                <strong>Original Document: </strong>
                                <span [innerHTML]="doc.description_original"></span>
                            </div>
                        }
                        @if (doc.description_copy) {
                            <div class="mb-2">
                                <strong>Copy Document: </strong>
                                <span [innerHTML]="doc.description_copy"></span>
                            </div>
                        }
                    </div>
                }

                @if (doc.rules && doc.rules.length > 0) {
                    <div class="doc-rules my-4">
                        <h3 class="fw-bold fs-5 mb-3 text-dark">
                            Rules for {{ doc.name }}
                        </h3>
                        <ul class="list-group shadow-sm border rounded-3 overflow-hidden">
                            @for (rule of doc.rules; track $index) {
                                <li class="list-group-item p-3 border-bottom">
                                    <h4 class="rule-title fs-6 fw-bold text-dark mb-1">
                                        <i class="bi bi-check2-circle text-success me-2"></i>
                                        {{ rule.title }}
                                    </h4>
                                    <p class="rule-description text-secondary mb-0 ms-4">
                                        {{ rule.description }}
                                    </p>
                                </li>
                            }
                        </ul>
                    </div>
                }
            }
        </div>


    </div>
    <div class="col-lg-6">
        @if (orderComplete()) {
            <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5); z-index: 1050;">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content border-0 shadow-lg">
                        <div class="modal-header border-bottom bg-light">
                            <h5 class="modal-title ms-3 fw-bold text-success">
                                <i class="bi bi-check-circle-fill me-2"></i>Order Completed Successfully!
                            </h5>
                            <button type="button" class="btn-close me-3" aria-label="Close" (click)="orderComplete.set(false); router.navigate(['/'])"></button>
                        </div>
                        <div class="modal-body p-4 bg-white">
                            <p class="ms-1 mb-4 text-muted fs-5">Your payment has been processed and your shipping labels are ready.</p>
                            
                            <!-- Custom Invoice View -->
                            <div class="invoice-wrapper mb-5">
                                <app-invoice [isModal]="true" [invoiceDataInput]="invoiceData()?.cart"></app-invoice>
                            </div>

                            <hr class="my-5">

                            <!-- FedEx Labels View -->
                            <div class="mt-4 px-2">
                                <h3 class="mb-4 fw-bold text-primary">Shipping Labels</h3>
                                <div class="row g-4">
                                    @for (label of fedexLabels(); track label) {
                                        <div class="col-12">
                                            <div class="card shadow-sm border-0">
                                                <div class="card-body p-0">
                                                    <iframe [src]="label | safeUrl" width="100%" height="600px" style="border: none; border-radius: 4px;"></iframe>
                                                </div>
                                                <div class="card-footer bg-light border-top-0 text-center py-3">
                                                    <a [href]="label" target="_blank" class="btn btn-primary px-4 fw-bold shadow-sm">
                                                        <i class="bi bi-printer-fill me-2"></i>Print / Download Label
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer bg-light border-top">
                            <button type="button" class="btn btn-secondary px-4 fw-bold" (click)="orderComplete.set(false); router.navigate(['/'])">
                                Finish & Return to Home
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        } @else if (thankYouComplete()) {
            <div class="final-view-container mt-4 mb-4 text-center">
                <div class="alert alert-success py-5">
                    <h2 class="alert-heading display-4 mb-4">Thank You!</h2>
                    <p class="lead">Your form has been successfully saved with your own shipping method.</p>
                    <hr class="my-4">
                    <p>You can download or print your filled document below.</p>
                    <a href="/" class="btn btn-primary btn-lg mt-3">Return to Home</a>
                </div>
            </div>
        }

        @if (pdfUrls()?.length) {
            <app-pdf-form-filler 
                #pdfFormFiller
                [pdfUrls]="pdfUrls()" 
                [fedexLoading]="fedexLoading()"
                [fedexError]="fedexError()"
                (shippingChoiceEvent)="onShippingChoice($event)"
                (requestPayment)="handlePaymentRequest($event)"
                (pdfCompleteEvent)="onPdfComplete()">
            </app-pdf-form-filler>
        }
    </div>
</div>

<div [hidden]="!showPaymentModal()">
    <div class="modal fade show d-block payment-modal-overlay" tabindex="-1" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 pb-0">
                    <h5 class="modal-title ms-3 mt-3 fw-bold">Complete Your Payment</h5>
                    <button type="button" class="btn-close me-3 mt-3" aria-label="Close" (click)="showPaymentModal.set(false)"></button>
                </div>
                <div class="modal-body p-0">
                    @if (paymentErrorMessage()) {
                        <div class="alert alert-danger mx-4 mt-3 mb-0">{{ paymentErrorMessage() }}</div>
                    }
                    <app-payment 
                        [isModal]="true"
                        [cartDataInput]="paymentCartData()"
                        (paymentSuccessEvent)="onPaymentSuccess($event)"
                        (paymentErrorEvent)="onPaymentError($event)">
                    </app-payment>
                </div>
            </div>
        </div>
    </div>
</div>